<template>
  <div class="split-rule-detail-manage">
    <!-- 面包屑导航 -->
    <!-- 卡片容器 -->
    <el-card>
      <!-- 搜索表单 -->
      <div class="filter-container">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="规则ID">
            <el-input v-model="searchForm.ruleId" placeholder="请输入规则ID" :disabled="true" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="分账类型">
            <el-select v-model="searchForm.splitType" placeholder="请选择分账类型" clearable style="width: 200px;">
              <el-option label="平台方" :value=1></el-option>
              <el-option label="商户方" :value=2></el-option>
              <el-option label="其他方" :value=3></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分账目标名称">
            <el-input v-model="searchForm.splitTargetName" placeholder="请输入分账目标名称" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" style="background-color: #3CA757; border-color: #3CA757;">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
            <el-button type="primary" @click="handleAdd" style="background-color: #3CA757; border-color: #3CA757;">新增分账规则明细</el-button>
          </el-form-item>
        </el-form>
      </div>

			<!-- 分账规则明细列表区 -->
			<el-table :data="tableData" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="60"></el-table-column>
				<!-- <el-table-column prop="ruleId" label="规则ID"></el-table-column> -->
				<el-table-column prop="splitType" label="分账类型">
					<template slot-scope="scope">
						<span>{{ getSplitTypeName(scope.row.splitType) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="splitTargetId" label="分账目标ID"></el-table-column>
				<el-table-column prop="splitTargetName" label="分账目标名称"></el-table-column>
				<el-table-column prop="splitRatio" label="分账比例">
					<template slot-scope="scope">
						<span v-if="scope.row.splitRatio">{{ (scope.row.splitRatio * 100).toFixed(2) }}%</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="splitAmount" label="固定分账金额">
					<template slot-scope="scope">
						<span v-if="scope.row.splitAmount">¥{{ scope.row.splitAmount.toFixed(2) }}</span>
					</template>
				</el-table-column> -->
				<!-- <el-table-column prop="minAmount" label="最小分账金额">
					<template slot-scope="scope">
						<span v-if="scope.row.minAmount">¥{{ scope.row.minAmount.toFixed(2) }}</span>
					</template>
				</el-table-column> -->
				<!-- <el-table-column prop="maxAmount" label="最大分账金额">
					<template slot-scope="scope">
						<span v-if="scope.row.maxAmount">¥{{ scope.row.maxAmount.toFixed(2) }}</span>
					</template>
				</el-table-column> -->
				<el-table-column prop="priority" label="优先级"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="120" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit"
							@click="handleEdit(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pagination.current" :page-sizes="[10, 20, 50, 100]"
				:page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="规则ID" prop="ruleId">
          <el-input v-model="form.ruleId" placeholder="请输入规则ID" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="分账类型" prop="splitType">
          <el-select v-model="form.splitType" placeholder="请选择分账类型" style="width: 100%">
            <el-option label="平台方" :value=1></el-option>
            <el-option label="商户方" :value=2></el-option>
            <el-option label="其他方" :value=3></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分账目标ID" prop="splitTargetId">
          <el-input v-model="form.splitTargetId" placeholder="请输入分账目标ID"></el-input>
        </el-form-item>
        <el-form-item label="分账目标名称" prop="splitTargetName">
          <el-input v-model="form.splitTargetName" placeholder="请输入分账目标名称"></el-input>
        </el-form-item>
        <el-form-item label="分账比例" prop="splitRatio">
          <el-input-number 
            v-model="form.splitRatio" 
            :precision="4" 
            :step="0.01" 
            :min="0" 
            :max="1" 
            style="width: 100%"
            placeholder="如0.05表示5%">
          </el-input-number>
        </el-form-item>
        <!-- <el-form-item label="固定分账金额" prop="splitAmount">
          <el-input-number 
            v-model="form.splitAmount" 
            :precision="2" 
            :step="0.01" 
            :min="0" 
            style="width: 100%"
            placeholder="请输入固定分账金额">
          </el-input-number>
        </el-form-item> -->
        <!-- <el-form-item label="最小分账金额" prop="minAmount">
          <el-input-number 
            v-model="form.minAmount" 
            :precision="2" 
            :step="0.01" 
            :min="0" 
            style="width: 100%"
            placeholder="请输入最小分账金额">
          </el-input-number>
        </el-form-item> -->
        <!-- <el-form-item label="最大分账金额" prop="maxAmount">
          <el-input-number 
            v-model="form.maxAmount" 
            :precision="2" 
            :step="0.01" 
            :min="0" 
            style="width: 100%"
            placeholder="请输入最大分账金额">
          </el-input-number>
        </el-form-item> -->
        <el-form-item label="优先级" prop="priority">
          <el-input-number 
            v-model="form.priority" 
            :min="0" 
            :max="999" 
            style="width: 100%"
            placeholder="数字越小优先级越高">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" style="background-color: #3CA757; border-color: #3CA757;">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: 'SplitRuleDetailManage',
  data() {
    return {
      searchForm: {
        ruleId: '',
        splitType: null,
        splitTargetName: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增分账规则明细',
      form: {
        id: '',
        ruleId: '',
        splitType: 1,
        splitTargetId: '',
        splitTargetName: '',
        splitRatio: 0,
        splitAmount: 0,
        minAmount: 0,
        maxAmount: 0,
        priority: 0
      },
      rules: {
        ruleId: [
          { required: true, message: '请输入规则ID', trigger: 'blur' }
        ],
        splitType: [
          { required: true, message: '请选择分账类型', trigger: 'change' }
        ],
        splitTargetId: [
          { required: true, message: '请输入分账目标ID', trigger: 'blur' }
        ],
        splitTargetName: [
          { required: true, message: '请输入分账目标名称', trigger: 'blur' }
        ],
        priority: [
          { required: true, message: '请输入优先级', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 如果从路由参数中获取ruleId，则设置到搜索表单中
    if (this.$route.query.ruleId) {
      this.searchForm.ruleId = this.$route.query.ruleId
    }
    this.fetchData()
  },
  methods: {
    getSplitTypeName(type) {
      switch (type) {
        case 1:
          return '平台方'
        case 2:
          return '商户方'
        case 3:
          return '其他方'
        default:
          return '未知'
      }
    },
    fetchData() {
      const req = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.searchForm
      }
      this.$http.post('/split/rule/detail/list', req).then(response => {
        if (response.data.code === 200) {
          this.tableData = response.data.data.list
          this.pagination.total = response.data.data.total
        } else {
          this.$message.error(response.data.msg || '获取数据失败')
        }
      }).catch(error => {
        this.$message.error('获取数据失败')
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    resetSearch() {
      this.searchForm = {
        ruleId: '',
        splitType: null,
        splitTargetName: ''
      }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchData()
    },
    handleAdd() {
      this.dialogTitle = '新增分账规则明细'
      this.form = {
        id: '',
        ruleId: this.searchForm.ruleId || '',
        splitType: 1,
        splitTargetId: '',
        splitTargetName: '',
        splitRatio: 0,
        splitAmount: 0,
        minAmount: 0,
        maxAmount: 0,
        priority: 0
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑分账规则明细'
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('确认删除该分账规则明细吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete('/split/rule/detail/' + row.id).then(response => {
          if (response.data.code === 200) {
            this.$message.success('删除成功')
            this.fetchData()
          } else {
            this.$message.error(response.data.msg || '删除失败')
          }
        }).catch(error => {
          this.$message.error('删除失败')
        })
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            // 修改操作
            const updateReq = {
              id: this.form.id,
              ruleId: this.form.ruleId,
              splitType: this.form.splitType,
              splitTargetId: this.form.splitTargetId,
              splitTargetName: this.form.splitTargetName,
              splitRatio: this.form.splitRatio,
              splitAmount: this.form.splitAmount,
              priority: this.form.priority,
              remark: this.form.remark
            }
            this.$http.put('/split/rule/detail', updateReq).then(response => {
              if (response.data.code === 200) {
                this.$message.success('更新成功')
                this.dialogVisible = false
                this.fetchData()
              } else {
                this.$message.error(response.data.msg || '更新失败')
              }
            }).catch(error => {
              this.$message.error('更新失败')
            })
          } else {
            // 新增操作
            const addReq = {
              ruleId: this.form.ruleId,
              splitType: this.form.splitType,
              splitTargetId: this.form.splitTargetId,
              splitTargetName: this.form.splitTargetName,
              splitRatio: this.form.splitRatio,
              splitAmount: this.form.splitAmount,
              priority: this.form.priority,
              remark: this.form.remark
            }
            this.$http.post('/split/rule/detail', addReq).then(response => {
              if (response.data.code === 200) {
                this.$message.success('保存成功')
                this.dialogVisible = false
                this.fetchData()
              } else {
                this.$message.error(response.data.msg || '保存失败')
              }
            }).catch(error => {
              this.$message.error('保存失败')
            })
          }
        }
      })
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.split-rule-detail-manage {
  padding: 20px;
}

.filter-container {
  padding-bottom: 10px;
}

.filter-container .el-form-item {
  margin-bottom: 10px;
}
</style>